export default [
    {
        dataKey: 'title',
        title: 'Title',
        width: 24,
    },
    {
        dataKey: 'season',
        title: 'Season',
        width: 1,
    }, {
        dataKey: 'episode',
        title: 'Episode',
        width: 1,
    },
    {
        dataKey: 'contentTypeName',
        title: 'Content type',
        width: 8,
    },
    {
        dataKey: 'partner',
        title: 'Content partner',
        width: 10,
    },
];
